export default {
    path: '/coupon',
    redirect: { name: 'coupon' },
    component: () => import('@/pages/s'),
    children: [
        {
            path: 'index',
            name: 'coupon',
            component: () => import('@/pages/coupon/coupon.vue')
        },
        {
            path: 'exchangeCoupon',
            name: 'exchangeCoupon',
            component: () => import('@/pages/coupon/exchangeCoupon.vue')
        },
    ]
}